angular.module('app.factories').factory('DialogService', ($mdDialog) => ({
    fromTemplate(template, $scope) {
        const options = {
            templateUrl: `./views/dialogs/${template}/${template}.html`,
        };

        if ($scope) {
            options.scope = $scope.$new();
        }

        return $mdDialog.show(options);
    },

    hide() {
        return $mdDialog.hide();
    },

    alert(title, content) {
        $mdDialog.show($mdDialog.alert().title(title).content(content).ok('Ok'));
    },
}));
